import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { UIBadgeModule } from '@fry/ui/badge';
import { MaterialModule } from '@fry/components/material';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';

import { EasFormModule } from '@fry/components/common/easform/easform.module';

import { WorkflowCreateFormComponent } from './workflow-create-form/workflow-create-form.component';
import { WorkflowEditFormComponent } from './workflow-edit-form/workflow-edit-form.component';
import { WorkflowEditorComponent } from './workflow-editor.component';

import { EditorWorkflowDialogComponent } from './workflow-dialog/editor-workflow-dialog.component';
import { EditorWorkflowDialogDeleteComponent } from './workflow-dialog-delete/editor-workflow-dialog-delete.component';
import { WorkflowPreviewComponent } from './workflow-preview/workflow-preview.component';
import {
  WorkflowTransitionListComponent,
  WorkflowTransitionActionFormComponent,
  WorkflowTransitionActionListComponent,
  WorkflowTransitionActionRefundOptionsFormComponent,
  WorkflowTransitionActionFillInFieldsFormComponent,
  WorkflowTransitionFormComponent,
  WorkflowTransitionGuardFormComponent,
  WorkflowTransitionGuardListComponent,
  WorkflowTransitionItemComponent,
  WorkflowTransitionsEditorComponent,
  WorkflowInitialTransitionFormComponent,
} from './transitions-editor';
import { WorkflowFormFieldFilterControl } from './transitions-editor/transition-guard/form-field-filter.control';

import {
  WorkflowFormEditorComponent,
  WorkflowFormFieldFormComponent,
  WorkflowFormFieldFormVisibilityComponent,
  WorkflowFormFieldItemComponent,
  WorkflowFormFieldListComponent,
  WorkflowFormPreviewComponent,
} from './form-editor';

import {
  WorkflowAuditIssueListComponent,
  WorkflowAuditIssueListItemComponent,
  WorkflowAuditResultButtonComponent
} from './workflow-audit';

import { FUIPopoverModule } from '@fry/ui-material/popover';
import { FUIFieldsetLegendModule } from '@fry/ui-material/fieldset-legend';
import { FUIValueListControlModule } from '@fry/ui-material/value-list-control';

import {
  WorkflowStatesEditorComponent,
  WorkflowStatesListItemComponent,
  WorkflowStateFormComponent,
} from './states-editor';
import { QuillModule } from 'ngx-quill';

@NgModule({
  declarations: [
    EditorWorkflowDialogComponent,
    EditorWorkflowDialogDeleteComponent,
    WorkflowAuditIssueListComponent,
    WorkflowAuditIssueListItemComponent,
    WorkflowAuditResultButtonComponent,
    WorkflowCreateFormComponent,
    WorkflowEditFormComponent,
    WorkflowEditorComponent,
    WorkflowFormEditorComponent,
    WorkflowFormFieldFormComponent,
    WorkflowFormFieldFormVisibilityComponent,
    WorkflowFormFieldItemComponent,
    WorkflowFormFieldListComponent,
    WorkflowFormPreviewComponent,
    WorkflowInitialTransitionFormComponent,
    WorkflowPreviewComponent,
    WorkflowTransitionActionFormComponent,
    WorkflowTransitionActionListComponent,
    WorkflowTransitionActionRefundOptionsFormComponent,
    WorkflowTransitionActionFillInFieldsFormComponent,
    WorkflowTransitionFormComponent,
    WorkflowTransitionGuardFormComponent,
    WorkflowTransitionGuardListComponent,
    WorkflowTransitionItemComponent,
    WorkflowTransitionListComponent,
    WorkflowTransitionsEditorComponent,
    WorkflowFormFieldFilterControl,
    WorkflowStatesEditorComponent,
    WorkflowStatesListItemComponent,
    WorkflowStateFormComponent,
  ],
  imports: [
    CommonModule,
    EasFormModule,
    FormsModule,
    UIBadgeModule,
    FUIFieldsetLegendModule,
    FUIPopoverModule,
    FUIValueListControlModule,
    MatButtonToggleModule,
    MatDialogModule,
    MaterialModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    QuillModule.forRoot({
      bounds: 'quill-editor', // or a different css selector, see DK-3247
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          [{ 'size': ['small', false, 'large', 'huge'] }],
          [{ 'align': [] }],
          ['link'],
          ['clean'],
        ]
      }
    }),
  ],
  exports: [
    EditorWorkflowDialogComponent
  ],
  providers: [
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        autoFocus: true,
        closeOnNavigation: true,
        disableClose: false,
        hasBackdrop: true,
      }
    },
  ]
})
export class WorkflowEditorModule {
  constructor() {}
}
